import moment from "moment";

// Contexts
import { getConfigProperty } from "../../../core/EnvironmentConfig/EnvironmentConfig";
// Types
import {
  INVOICES_SUMMARY_REQUEST_START,
  INVOICES_SUMMARY_REQUEST_FAIL,
  INVOICES_SUMMARY_REQUEST_SUCCESS,
  ANNUAL_STATEMENT_DOWNLOAD_REQUEST_RESET,
  ANNUAL_STATEMENT_DOWNLOAD_REQUEST_START,
  ANNUAL_STATEMENT_DOWNLOAD_REQUEST_FAIL,
  ANNUAL_STATEMENT_DOWNLOAD_REQUEST_SUCCESS,
} from "./types";
// Redux
import { affiliate, get, post } from "./../session/actions";
import { getServicesErrorObj } from "../servicesDowntime/actions";
// Utils
import { convert } from "./utils/convert";
import { PdfSaveAs } from "../../../core/utils/PDFGenerate";
import base64ToBlob from "../../../core/utils/Base64ToBlob";

export const INVOICES_SUMMARY_URL: Function = () => {
  const affiliateId: string = affiliate();

  const invoiceAPIKey: string = getConfigProperty("apiKey")["invoice"];

  return `/v1/invoices/affiliate/${affiliateId}?apikey=${invoiceAPIKey}`;
};

export const INVOICE_DOWNLOAD_API_URL: string = `/v1/affiliate/invoice/download`;

export const ANNUAL_STATEMENT_DOWNLOAD_API_URL = ({
  affiliateNumber,
  taxYear,
  legalEntity,
  selectedAffiliateFilter,
}) =>
  `/affiliate-engine/invoiceTaxCertificates/generateTaxCertificate?affiliateNumber=${affiliateNumber}&taxYear=${taxYear}${selectedAffiliateFilter && "&selectedAffiliateFilter=" + selectedAffiliateFilter}${legalEntity && "&legalEntity=" + legalEntity}`;

export const invoicesSummaryRequestStart = () => ({
  type: INVOICES_SUMMARY_REQUEST_START,
});

export const invoicesSummaryRequestFail = () => ({
  type: INVOICES_SUMMARY_REQUEST_FAIL,
});

export const invoicesSummaryRequestSuccess = (payload: any) => ({
  type: INVOICES_SUMMARY_REQUEST_SUCCESS,
  payload,
});

export const annualStatementDownloadRequestStart = () => ({
  type: ANNUAL_STATEMENT_DOWNLOAD_REQUEST_START,
});

export const annualStatementDownloadRequestFail = () => ({
  type: ANNUAL_STATEMENT_DOWNLOAD_REQUEST_FAIL,
});

export const annualStatementDownloadRequestSuccess = (payload: any) => ({
  type: ANNUAL_STATEMENT_DOWNLOAD_REQUEST_SUCCESS,
  payload,
});
export const annualStatementDownloadRequestReset = () => ({
  type: ANNUAL_STATEMENT_DOWNLOAD_REQUEST_RESET,
});

export const getInvoicesSummary =
  (translate: Function) => (dispatch: Function) =>
    new Promise((resolve, reject) => {
      dispatch(invoicesSummaryRequestStart());

      dispatch(get(INVOICES_SUMMARY_URL()))
        .then((response: any) => {
          if (response && response.data) {
            const sortedData: { [keyName: string]: string | number }[] =
              response.data.sort(
                (a: { InvoiceDate: string }, b: { InvoiceDate: string }) => {
                  const date1: number = moment(a.InvoiceDate).valueOf();
                  const date2: number = moment(b.InvoiceDate).valueOf();

                  return date2 - date1;
                },
              );
            const parsed: any = convert(sortedData, translate);

            dispatch(invoicesSummaryRequestSuccess(parsed));
            resolve(parsed);
          } else {
            dispatch(invoicesSummaryRequestFail());
            resolve(false);
          }
        })
        .catch((error: any) => {
          dispatch(invoicesSummaryRequestFail());
          dispatch(getServicesErrorObj(error));
          resolve(false);
        });
    });

export const downloadInvoiceFile =
  (postFileDownloadAction: Function, fieldPDFName: string = "") =>
  (dispatch: Function) =>
    new Promise((resolve) => {
      const payload = {
        invoiceNo: fieldPDFName,
      };
      dispatch(post(INVOICE_DOWNLOAD_API_URL, payload))
        .then(async (response: any) => {
          if (response && response.data) {
            const { InvoiceByte } = response.data || {};

            postFileDownloadAction(true);

            const resultBlob = await base64ToBlob(InvoiceByte);

            if (resultBlob) {
              PdfSaveAs(resultBlob, fieldPDFName);
            }
            resolve(true);
          } else {
            postFileDownloadAction(false);
            resolve(false);
          }
        })
        .catch((error: any) => {
          dispatch(getServicesErrorObj(error));
          postFileDownloadAction(false);
          resolve(false);
        });
    });

export const downloadAnnualStatementFile =
  (
    taxYear: string = "",
    selectedAffiliateFilter: string = "",
    legalEntity: string = "",
  ) =>
  (dispatch: Function) =>
    new Promise((resolve, reject) => {
      const payload = {
        affiliateNumber: affiliate(),
        taxYear: taxYear,
        legalEntity: legalEntity,
        selectedAffiliateFilter,
      };
      dispatch(annualStatementDownloadRequestStart());
      dispatch(get(ANNUAL_STATEMENT_DOWNLOAD_API_URL(payload)))
        .then(async (response: any) => {
          if (response && response.data) {
            dispatch(annualStatementDownloadRequestSuccess(response.data));
            resolve(response.data);
          } else {
            dispatch(annualStatementDownloadRequestFail());
            resolve(false);
          }
        })
        .catch((error: any) => {
          dispatch(annualStatementDownloadRequestFail());
          dispatch(getServicesErrorObj(error));
          resolve(false);
        });
    });

export const resetGenerateStatementStoreData = () => (dispatch: Function) => {
  dispatch(annualStatementDownloadRequestReset());
};

export type InvoicesSummaryAction = {
  type: string;
  payload?: any;
};
